<script lang="ts">
    export let show = false;
    export let width = '95vw';
    export let height = '95vh';
    export let toggleCallback:Function = () => {};

    let customStyle = `top: calc(((100vh - ${height}) + 10px)/2); left: calc((100vw - ${width})/2);`;
    customStyle += `height: calc(${height}); width: calc(${width});`;
</script>

<div class="modal-parent" style={`display:${show ? 'block': 'none'}`}>
    <div class="modal-overlay">
    </div>
    <div class="modal-container" style={customStyle}>
        <div class="modal-close-button-box">
            <i class="far fa-times-circle modal-close-button" on:click={() => toggleCallback(false)}></i>
        </div>
        <div class="modal-box" style={`height:calc(${height} - 60px)`}>
            <slot></slot>
        </div>
    </div>
</div>

<style>
    .modal-parent {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: transparent;
        z-index: 10003;
    }

    .modal-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: black;
        opacity: .8;
        z-index: 9;
    }

    .modal-container {
        position: absolute;
        top: 30%;
        max-width: 98vw;
        max-height: 98vh;
        z-index: 10;
        background-color: white;
        overflow: hidden;
    }

    .modal-close-button-box {
        width: 100%;
        display: flex;
        justify-content: end;
        color: black;
        font-size: 25px;
        padding: 7px;
        height: 50px;
    }

    .modal-close-button {
        cursor: pointer;
    }

    .modal-box {
        padding: 10px;
        background-color: white;
        overflow: auto;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>